module.exports = __webpack_public_path__ + "img/d9eb7fe.png";